export default __webpack_public_path__ + "static/media/computer.327f6c75.svg";